import { Button, Grid, Typography } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import LoginSelect from '../LoginSelect/LoginSelect';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Circles } from 'react-loader-spinner';
import CustomToast from "../CustomToast/CustomToast";
import { useCountry } from "../../Context/CountryContext";
import { fetchCountries, forgetPasswordRequest, resetPasswordRequest } from './forgetPasswordApi';
import LoadingOverlay from './LoadingOverlay';
import HeaderLogo from './HeaderLogo';
import ResetForm from './ResetForm';
import ForgetForm from './ForgetForm';


const ForgetPasswordComponent = () => {


    const { countryId } = useCountry();
    let navigate = useNavigate()


    const [phoneError, setPhoneError] = useState('');
    const [phoneValue, setPhoneValue] = useState('');
    const [country, setCountry] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [countryError, setCountryError] = useState('');
    const [reset, setReset] = useState(false);
    const [passwordValue, setPasswordValue] = useState('')
    const [tokenValue, setTokenValue] = useState('')



    const handleChangePhoneValue = (e) => {
        setPhoneValue(e.target.value)
    }

    const handleChangePasswordValue = (e) => {
        setPasswordValue(e.target.value)
    }


    const handleChangeTokenValue = (e) => {
        setTokenValue(e.target.value)
    }


    const handleForgetPassword = async () => {
        setLoading(true);
        try {
            const { data } = await forgetPasswordRequest({ phone: Number(phoneValue), countryId });
            setLoading(false);
            if (data.status) {
                setReset(true);
            } else {
                if (data.errors.length > 0) {
                    toast(<CustomToast message={data.errors[0]} state="error" />);
                }
                setPhoneError(data.validations.phone && data.validations.phone[0]);
            }
        } catch (err) {
            console.error('Error:', err);
            setLoading(false);
        }
    };



    const handleResetPassword = async () => {
        setLoading(true);
        try {
            const { data } = await resetPasswordRequest({
                phone: Number(phoneValue),
                countryId,
                password: passwordValue,
                token: Number(tokenValue),
            });
            setLoading(false);
            if (data.status) {
                navigate('/');
            } else {
                if (data.errors.length > 0) {
                    toast(<CustomToast message={data.errors[0]} state="error" />);
                }
                setPhoneError(data.validations.phone && data.validations.phone[0]);
            }
        } catch (err) {
            console.error('Error:', err);
            setLoading(false);
        }
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await fetchCountries();
                setCountry(data.output);
            } catch (err) {
                console.error('Error:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);





    return (
        <>
            <LoadingOverlay loading={loading} />
            <HeaderLogo />
            <Grid width="90%" maxWidth="500px" mx="auto">
                {reset ? (
                    <ResetForm
                        passwordValue={passwordValue}
                        tokenValue={tokenValue}
                        phoneError={phoneError}
                        handleChangePasswordValue={handleChangePasswordValue}
                        handleChangeTokenValue={handleChangeTokenValue}
                        handleResetPassword={handleResetPassword}
                    />
                ) : (
                    <ForgetForm
                        phoneValue={phoneValue}
                        phoneError={phoneError}
                        country={country}
                        countryError={countryError}
                        handleChangePhoneValue={handleChangePhoneValue}
                        handleForgetPassword={handleForgetPassword}
                    />
                )}
                <Link to="/">
                    <Grid
                        position="fixed"
                        top={{ xs: '20px', sm: '40px' }}
                        right={{ xs: '20px', sm: '100px' }}
                        bgcolor="white"
                        borderRadius="20px"
                        p="12px"
                        display="flex"
                        alignItems="center"
                        gap="4px"
                    >
                        <ArrowBackIcon style={{ rotate: '180deg', color: '#FDA058' }} fontSize="large" />
                        <Grid display={{ xs: 'none', sm: 'block' }}>
                            <Typography variant="h4" color="#FDA058" fontWeight={700}>
                                بازگشت
                            </Typography>
                        </Grid>
                    </Grid>
                </Link>
            </Grid>
        </>

    )
}

export default ForgetPasswordComponent